document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-hb2-carousel]');

  sections.forEach(function (section) {
    var slides = section.querySelectorAll('[data-hb2-slide]');
    var dots = section.querySelectorAll('[data-hb2-dot]');
    var prevBtn = section.querySelector('[data-hb2-prev]');
    var nextBtn = section.querySelector('[data-hb2-next]');
    var total = slides.length;
    var current = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 6000;
    var timer = null;

    if (total <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      var dotsWrap = section.querySelector('[data-hb2-dots]');
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    function goTo(index) {
      current = (index + total) % total;

      // Crossfade: the CSS opacity transition on .hb2-slide handles the
      // smoothness; we just toggle the active class on all slides so the
      // outgoing one fades out while the incoming one fades in together.
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        stopAutoplay();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        stopAutoplay();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        goTo(index);
        stopAutoplay();
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  });
});